import { apiClient } from "lib/apiClient";
import { assistantPageCodeEnum } from "features/AssistantPages/constantTypes";

export const getChatKitAvailability = async (
  code: assistantPageCodeEnum
): Promise<boolean> => {
  const response = await apiClient.get(
    `/assistant/pages/${code}/chatkit/available`
  );

  return response.data;
};
